export const LOCALES = {
    default: {
        language: '',
        client: '',
        site: '',
        country: '',
    },
    'en-us': {
        language: 'eng',
        client: 'fpro-us',
        site: 'pro.ford.com',
        country: 'us',
    },
};
